export default __webpack_public_path__ + "static/media/011-lavender.2b865a84.svg";